import React, { useEffect, useState } from 'react';

import Byline from '@components/Byline';
import ArticleHeader from '@components/FeedItems/ArticleHeader';
import ArticleImage from '@components/FeedItems/ArticleImage';
import useEventTracking from '@hooks/useEventTracking';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { Theme } from '@interfaces/global';
import { Article } from '@interfaces/homepage';
import { ClickTarget, click } from '@tracking';
import { UtmParams, articlePathWithParams } from '@utils/queryStringHelper';

interface ModalArticleProps extends Article {
  utmParams: UtmParams;
}

const ModalArticle = ({
  id,
  isPro,
  picture,
  slug,
  title,
  authors,
  excerpt,
  utmParams,
  newsletterSlug,
}: ModalArticleProps) => {
  const { trackEvent } = useEventTracking();
  const isHydrated = useServerSideRendering();
  const [articlePath, setArticlePath] = useState('');

  useEffect(() => {
    if (!isHydrated) return;
    setArticlePath(
      articlePathWithParams({
        slug,
        utm: utmParams,
      })
    );
  }, [isHydrated, slug, isPro, utmParams]);

  return (
    <article>
      <div className="pl-24 sm:pl-88 md:pl-80">
        <ArticleImage
          className="aspect-[16/9] !h-auto w-[230px]"
          id={id}
          isPro={isPro}
          picture={picture}
          sizes="200px"
          slug={slug}
          title={title}
          utmParams={utmParams}
          newsletterSlug={newsletterSlug}
        />
        <ArticleHeader
          slug={slug}
          title={title}
          theme={Theme.Dark}
          className="!my-8 text-headline-xxs"
          utmParams={utmParams}
          newsletterSlug={newsletterSlug}
        />
        <Byline authors={authors} theme={Theme.Dark} newsletterSlug={newsletterSlug} />
      </div>
      <div className="mt-16 h-2 w-full bg-grayscale-gray" />
      <p className="mb-0 mt-16 hidden pl-88 font-suisse-intl text-overline-md text-white sm:block md:pl-80">
        <a
          href={articlePath}
          className="line-clamp-3 hover:text-primary-magenta"
          onClickCapture={() =>
            trackEvent(click({ clickTarget: ClickTarget.Excerpt, clickText: excerpt.long }))
          }
        >
          {excerpt.long}
        </a>
      </p>
    </article>
  );
};

export default ModalArticle;
